import { useState, useRef, useEffect } from "preact/compat";
import useAppDispatch from "~/hooks/use-app-dispatch.ts";
import { setParsedNameValues } from "~/features/user/store-slice.ts";
import NameForm, { type NameValues } from "~/features/nav/name-form.tsx";
import { useTranslator } from "@brickme/frontend-common/src/i18n/translation.tsx";

export default function NameCollectionStep() {
	const dispatch = useAppDispatch();
	const [isWorking, setIsWorking] = useState(false);
	const isMountedRef = useRef(true);
	const t = useTranslator();

	// Cleanup function to prevent state updates on unmounted component
	useEffect(() => {
		return () => {
			isMountedRef.current = false;
		};
	}, []);

	const handleNameSubmit = (nameValues: NameValues): Promise<void> => {
		setIsWorking(true);
		try {
			// Store parsed name values in Redux for later use
			dispatch(setParsedNameValues(nameValues));
		} finally {
			// Only update state if component is still mounted
			if (isMountedRef.current) {
				setIsWorking(false);
			}
		}
		return Promise.resolve();
	};

	return (
		<div className="get-started-step">
			<div className="get-started-content">
				<h1 className="get-started-title">{t("Let's get to know you")}</h1>

				<NameForm
					isWorking={isWorking}
					submitLabel={t("Continue")}
					onSubmit={handleNameSubmit}
				/>
			</div>
		</div>
	);
}
